import React, { useContext } from 'react'

import { ConfirmationDialog } from '../../../../components/Dialog'
import { Button } from '../../../../components/Button'
import { RemindersContext } from '../../context'

export const Destroy = () => {
  const {
    actions: { cancel, deleteReminder },
    state: { isDestroying, reminder }
  } = useContext(RemindersContext)
  return (
    <ConfirmationDialog
      heading='Are you sure you want to delete this reminder?'
      subheading={reminder.description}
      primaryButton={() =>
        <Button
          disabled={isDestroying}
          primary
          trackAs='Reminder: Delete Reminder'
          onClick={deleteReminder}
        >
          {isDestroying ? 'Deleting reminder...' : 'Delete Reminder'}
        </Button>}
      secondaryButton={() =>
        <Button
          disabled={isDestroying}
          secondary
          trackAs='Reminder: Cancel'
          onClick={cancel}
        >
          Take me back
        </Button>}
    />
  )
}
